import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'
import {fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions} from '../../../reusable'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'

import 'react-datepicker/dist/react-datepicker.css'
import {Link} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import Swal from 'sweetalert2'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faMinus, faPlus} from '@fortawesome/free-solid-svg-icons'
import {Tr} from '../../../_metronic/i18n/Tr'

const Popup = (props: any) => {
  let t = Tr()

  // add / edit facility states

  const [error, setError] = useState(Object)
  const [addloader, setaddLoader] = useState(false)
  const [disable, setDisable] = useState(false)
  const [carRentals, setCarRentals] = useState(
    props.passdata.data || [{en_name: '', ru_name: '', uz_name: ''}]
  )
  const [initalDataLength, setInitalDataLength] = useState('')

  const [carRentalsSecurity, setCarRentalsSecurity] = useState(
    props.passSecurityData.data || [{from: '', to: ''}]
  )
  const [carRentalsSeat, setCarRentalsSeat] = useState(props.passSeatData.data || [{seats: ''}])

  const addCarRentals = async () => {
    var tmp: any = [...carRentals, {en_name: '', ru_name: '', uz_name: ''}]
    setCarRentals(tmp)
  }
  const addCarRentalsSecurity = async () => {
    var tmp: any = [...carRentalsSecurity, {from: '', to: ''}]
    setCarRentalsSecurity(tmp)
  }
  const addCarRentalSeat = async () => {
    var tmp: any = [...carRentalsSeat, {seats: ''}]
    setCarRentalsSeat(tmp)
  }

  const handleCarRentalsChange = (index: number, field: string, value: string) => {
    var carRentalsSlots: any = [...carRentals]
    carRentalsSlots[index][field] = value
    setCarRentals(carRentalsSlots)
  }

  const handleCarRentalsSecurityChange = (index: number, field: string, value: string) => {
    if (!/^\d*$/.test(value)) {
      return // Exit early if the value is not numeric
    }
    var carRentalsSecuritySlots: any = [...carRentalsSecurity]
    carRentalsSecuritySlots[index][field] = value
    setCarRentalsSecurity(carRentalsSecuritySlots)
  }
  const handleCarRentalsSeatChange = (index: number, field: string, value: string) => {
    if (!/^\d*$/.test(value)) {
      return // Exit early if the value is not numeric
    }
    var carRentalsSeatSlots: any = [...carRentalsSeat]
    carRentalsSeatSlots[index][field] = value
    setCarRentalsSeat(carRentalsSeatSlots)
  }

  const removeCarRentals = (id: number, index: number) => {
    // Create a copy of the Car Rentals array

    if (id == null || id == undefined) {
      if (carRentals.length === 1) {
        Swal.fire({
          icon: 'error',
          title: t('Cannot Remove All Rows'),
          text: t('At least one row must be present'),
        })
      } else {
        const updateCarRentals = [...carRentals]

        // Remove the element at the specified index
        updateCarRentals.splice(index, 1)

        // Update the state with the new array
        setCarRentals(updateCarRentals)
      }
    } else {
      if (carRentals.length === 1) {
        Swal.fire({
          icon: 'error',
          title: t('Cannot Remove All Rows'),
          text: t('At least one row must be present'),
        })
      } else {
        var tmp2 = sessionStorage.getItem('admin')
        // Step 2: Check if the item is not null
        if (tmp2) {
          // Step 3: Parse the JSON string
          var adminData = JSON.parse(tmp2)
          // Step 4: Access the adminId
          var adminId = adminData.adminId
        }

        Swal.fire({
          title: t('Are you sure?'),
          text: t('You Want To Delete this row!'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: t('Ok'), // Custom OK button text
          cancelButtonText: t('Cancel'), // Custom Cancel button text',
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              var param: any = {
                adminId: adminId,
                id: id,
              }

              const response = await fetchData('admin/delete' + props.passdata.apiName, param)

              if (response.status == '200') {
                const updateCarRentals = [...carRentals]

                // Remove the element at the specified index
                updateCarRentals.splice(index, 1)

                // Update the state with the new array
                setCarRentals(updateCarRentals)
                toastsuccessmsg('Deleted Successfully')
              } else {
                toasterrormsg(response.message)
              }
            } catch (error) {
              // Handle error as needed
              toasterrormsg('An error occurred while processing your request.')
            }
          }
        })
      }
    }
  }
  const removcarrentalsecurity = (id: number, index: number) => {
    // Create a copy of the Car Rentals array

    if (id == null || id == undefined) {
      if (carRentalsSecurity.length === 1) {
        Swal.fire({
          icon: 'error',
          title: t('Cannot Remove All Rows'),
          text: t('At least one row must be present'),
        })
      } else {
        const updateCarRentalsSecurity = [...carRentalsSecurity]

        // Remove the element at the specified index
        updateCarRentalsSecurity.splice(index, 1)

        // Update the state with the new array
        setCarRentalsSecurity(updateCarRentalsSecurity)
      }
    } else {
      if (carRentalsSecurity.length === 1) {
        Swal.fire({
          icon: 'error',
          title: t('Cannot Remove All Rows'),
          text: t('At least one row must be present'),
        })
      } else {
        var tmp2 = sessionStorage.getItem('admin')
        // Step 2: Check if the item is not null
        if (tmp2) {
          // Step 3: Parse the JSON string
          var adminData = JSON.parse(tmp2)
          // Step 4: Access the adminId
          var adminId = adminData.adminId
        }

        Swal.fire({
          title: t('Are you sure?'),
          text: t('You Want To Delete this row!'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: t('Ok'), // Custom OK button text
          cancelButtonText: t('Cancel'), // Custom Cancel button text
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              var param: any = {
                adminId: adminId,
                id: id,
              }

              const response = await fetchData(
                'admin/delete' + props.passSecurityData.apiName,
                param
              )

              if (response.status == '200') {
                const updateCarRentalsSecurity = [...carRentalsSecurity]

                // Remove the element at the specified index
                updateCarRentalsSecurity.splice(index, 1)

                // Update the state with the new array
                setCarRentalsSecurity(updateCarRentalsSecurity)
                toastsuccessmsg('Deleted Successfully')
              } else {
                toasterrormsg(response.message)
              }
            } catch (error) {
              toasterrormsg('An error occurred while processing your request.')
            }
          }
        })
      }
    }
  }
  const removcarrentalseat = (id: number, index: number) => {
    // Create a copy of the Car Rentals array

    if (id == null || id == undefined) {
      if (carRentalsSeat.length === 1) {
        Swal.fire({
          icon: 'error',
          title: t('Cannot Remove All Rows'),
          text: t('At least one row must be present'),
        })
      } else {
        const updateCarRentalsSeat = [...carRentalsSeat]

        // Remove the element at the specified index
        updateCarRentalsSeat.splice(index, 1)

        // Update the state with the new array
        setCarRentalsSecurity(updateCarRentalsSeat)
      }
    } else {
      if (carRentalsSeat.length === 1) {
        Swal.fire({
          icon: 'error',
          title: t('Cannot Remove All Rows'),
          text: t('At least one row must be present'),
        })
      } else {
        var tmp2 = sessionStorage.getItem('admin')
        // Step 2: Check if the item is not null
        if (tmp2) {
          // Step 3: Parse the JSON string
          var adminData = JSON.parse(tmp2)
          // Step 4: Access the adminId
          var adminId = adminData.adminId
        }

        Swal.fire({
          title: t('Are you sure?'),
          text: t('You Want To Delete this row!'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: t('Ok'), // Custom OK button text
          cancelButtonText: t('Cancel'), // Custom Cancel button text
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              var param: any = {
                adminId: adminId,
                id: id,
              }
              const response = await fetchData('admin/delete' + props.passSeatData.apiName, param)
              if (response.status == '200') {
                const updateCarRentalsSeat = [...carRentalsSeat]

                // Remove the element at the specified index
                updateCarRentalsSeat.splice(index, 1)

                // Update the state with the new array
                setCarRentalsSeat(updateCarRentalsSeat)
                toastsuccessmsg('Deleted Successfully')
              } else {
                toasterrormsg(response.message)
              }
            } catch (error) {
              toasterrormsg('An error occurred while processing your request.')
            }
          }
        })
      }
    }
  }

  const saveCarRentals = async () => {
    setDisable(true)

    var tmp2 = sessionStorage.getItem('admin')
    // Step 2: Check if the item is not null
    if (tmp2) {
      // Step 3: Parse the JSON string
      var adminData = JSON.parse(tmp2)
      // Step 4: Access the adminId
      var adminId = adminData.adminId
    }

    if (props.passSecurityData.apiName == 'securitydeposite') {
      for (const item of carRentalsSecurity) {
        const param = {
          from: item.from,
          to: item.to,
          id: item.id,
          categoryId: '7',
          adminId: adminId,
        }

        var res = await fetchData('admin/addEdit' + props.passSecurityData.apiName, param)
      }
    } else if (props.passSeatData.apiName == 'seatnumber') {
      for (const item of carRentalsSeat) {
        const param = {
          seats: item.seats,
          categoryId: '7',
          adminId: adminId,
          id: item.id,
        }

        var res = await fetchData('admin/addEdit' + props.passSeatData.apiName, param)
      }
    } else {
      for (const item of carRentals) {
        const param = {
          enName: item.en_name.trim(),
          ruName: item.ru_name.trim(),
          uzName: item.uz_name.trim(),
          id: item.id,
          categoryId: '7',
          adminId: adminId,
        }

        var res = await fetchData('admin/addEdit' + props.passdata.apiName, param)
      }
    }
    if (res.status == '200') {
      toastsuccessmsg('Updated Successfully')

      // setaddLoader(false)
      setDisable(false)
      props.onHide()
    } else {
      setaddLoader(false)
      setDisable(false)
      toasterrormsg(res.message)
    }
  }
  const validate = () => {
    var errotmp: any = {}
    var err = 0

    if (props.passSecurityData.apiName == 'securitydeposite') {
      carRentalsSecurity.forEach((carRentalsSecuritySlot: any, index: any) => {
        // Validate 'from' value
        if (
          carRentalsSecuritySlot.from == '' ||
          carRentalsSecuritySlot.from == null ||
          carRentalsSecuritySlot.from == undefined ||
          carRentalsSecuritySlot.from == 0
        ) {
          errotmp[`from${index}`] = t('From value is Required')
          err = 1
        } else if (
          index > 0 &&
          carRentalsSecurity[index - 1].to &&
          parseFloat(carRentalsSecuritySlot.from) <= parseFloat(carRentalsSecurity[index - 1].to)
        ) {
          errotmp[`from${index}`] = ` ${t(
            "From value must be greater than the previous row's To value"
          )} (${carRentalsSecurity[index - 1].to})`
          err = 1
        }

        // Validate 'to' value
        if (
          carRentalsSecuritySlot.to == '' ||
          carRentalsSecuritySlot.to == null ||
          carRentalsSecuritySlot.to == undefined ||
          carRentalsSecuritySlot.to == 0
        ) {
          errotmp[`to${index}`] = t('To value is Required')
          err = 1
        } else if (
          parseFloat(carRentalsSecuritySlot.from) >= parseFloat(carRentalsSecuritySlot.to)
        ) {
          errotmp[`to${index}`] = t('To value must be greater than From value')
          err = 1
        }
      })
    } else if (props.passSeatData.apiName == 'seatnumber') {
      carRentalsSeat.forEach((carRentalsSeatSlot: any, index: any) => {
        // Validate 'from' value
        if (
          carRentalsSeatSlot.seats == '' ||
          carRentalsSeatSlot.seats == null ||
          carRentalsSeatSlot.seats == undefined ||
          carRentalsSeatSlot.seats == 0
        ) {
          errotmp[`seats${index}`] = t('Seat Number Is Required')
          err = 1
        } else if (isNaN(carRentalsSeatSlot.seats)) {
          errotmp[`seats${index}`] = t('Seat Number Is Not Valid')
          err = 1
        }
      })
    } else {
      carRentals.forEach((carRentalsSlot: any, index: any) => {
        if (
          carRentalsSlot.en_name.trim() == '' ||
          carRentalsSlot.en_name.trim() == null ||
          carRentalsSlot.en_name.trim() == undefined
        ) {
          errotmp[`en_name${index}`] = t('Property Category English Name Is Required')
          err = 1
        } else if (carRentalsSlot.en_name.trim().length > 50) {
          errotmp[`en_name${index}`] = t('Property Category English Name Is Too Large')
          err = 1
        } else if (
          carRentalsSlot.ru_name.trim() == '' ||
          carRentalsSlot.ru_name.trim() == null ||
          carRentalsSlot.ru_name.trim() == undefined
        ) {
          errotmp[`ru_name${index}`] = t('Property Category Russian Name Is Required')
          err = 1
        } else if (carRentalsSlot.ru_name.trim().length > 50) {
          errotmp[`ru_name${index}`] = t('Property Category Russian Name Is Too Large')
          err = 1
        } else if (
          carRentalsSlot.uz_name.trim() == '' ||
          carRentalsSlot.uz_name.trim() == null ||
          carRentalsSlot.uz_name.trim() == undefined
        ) {
          errotmp[`uz_name${index}`] = t('Property Category Uzbek Name Is Required')
          err = 1
        }
      })
    }
    setError(errotmp)
    if (err == 0) {
      saveCarRentals()
    }
  }

  useEffect(() => {
    setInitalDataLength(props.passdata.data.length)
  }, [])

  // add / edit facility state end
  return (
    <Modal
      {...props}
      size='xl'
      aria-labelledby='contained-modal-title-hcenter'
      dialogClassName='maxwidth1000px'
      centered
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header closeButton>
        <div className='d-flex align-items-center col-10'>
          <h4 className='fw-bold'>
            {props.passdata !== '' ? t('Edit') : t('Add')} {t('Filters')}
          </h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div
          className='stepper stepper-links d-flex flex-column'
          id='kt_create_account_stepper'
          data-kt-stepper='true'
        >
          <div className='mx-auto w-100 py-10 row' id='kt_create_account_form'>
            <label className='h3 mb-5'>{t('Add Filter Values')}</label>
            <div className='row'>
              {props.passSecurityData.apiName == 'securitydeposite'
                ? carRentalsSecurity.map((item: any, index: any) => {
                    return (
                      <div className='col-10' key={index}>
                        <div className='row'>
                          <div className='col-lg-3 col-xl-4'>
                            <label className='required fw-bold fs-6'>{t('From')}</label>
                            <input
                              type='text'
                              name='from'
                              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              placeholder={t('From')}
                              value={item.from}
                              onChange={(event: any) =>
                                handleCarRentalsSecurityChange(index, 'from', event.target.value)
                              }
                            ></input>
                            <label className='text-danger'>{error[`from${index}`] || ''}</label>
                          </div>
                          <div className='col-lg-3 col-xl-4'>
                            <label className='required fw-bold fs-6'>{t('To')}</label>
                            <input
                              type='text'
                              name='to'
                              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              placeholder={t('To')}
                              value={item.to}
                              onChange={(event: any) =>
                                handleCarRentalsSecurityChange(index, 'to', event.target.value)
                              }
                            ></input>
                            <label className='text-danger'>{error[`to${index}`] || ''}</label>
                          </div>

                          <div className='col-lg-3 col-xl-1'>
                            <div className='col-2' style={{textAlign: 'right', marginTop: '1rem'}}>
                              <label
                                onClick={() => removcarrentalsecurity(item.id, index)}
                                className='btn btn-danger'
                              >
                                <FontAwesomeIcon icon={faMinus} />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })
                : props.passSeatData.apiName == 'seatnumber'
                ? carRentalsSeat.map((item: any, index: any) => {
                    return (
                      <div className='col-10' key={index}>
                        <div className='row'>
                          <div className='col-lg-3 col-xl-4'>
                            <label className='required fw-bold fs-6'>{t('Seats')}</label>
                            <input
                              type='text'
                              name='seats'
                              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              placeholder={t('Seats')}
                              value={item.seats}
                              onChange={(event: any) =>
                                handleCarRentalsSeatChange(index, 'seats', event.target.value)
                              }
                            ></input>
                            <label className='text-danger'>{error[`seats${index}`] || ''}</label>
                          </div>

                          <div className='col-lg-3 col-xl-1'>
                            <div className='col-2' style={{textAlign: 'right', marginTop: '1rem'}}>
                              <label
                                onClick={() => removcarrentalseat(item.id, index)}
                                className='btn btn-danger'
                              >
                                <FontAwesomeIcon icon={faMinus} />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })
                : carRentals.map((item: any, index: any) => {
                    return (
                      <div className='col-10' key={index}>
                        <div className='row'>
                          <div className='col-lg-3 col-xl-4'>
                            <label className='required fw-bold fs-6'>{t('English Value')}</label>
                            <input
                              type='text'
                              name='enName2'
                              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              placeholder={t('English Value')}
                              value={item.en_name}
                              onChange={(event: any) =>
                                handleCarRentalsChange(index, 'en_name', event.target.value)
                              }
                            ></input>
                            <label className='text-danger'>{error[`en_name${index}`] || ''}</label>
                          </div>
                          <div className='col-lg-3 col-xl-4'>
                            <label className='required fw-bold fs-6'>{t('Russian Value')}</label>
                            <input
                              type='text'
                              name='carrentalsname'
                              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              placeholder={t('Russian Value')}
                              value={item.ru_name}
                              onChange={(event: any) =>
                                handleCarRentalsChange(index, 'ru_name', event.target.value)
                              }
                            ></input>
                            <label className='text-danger'>{error[`ru_name${index}`] || ''}</label>
                          </div>
                          <div className='col-lg-3 col-xl-3'>
                            <label className='required fw-bold fs-6'>{t('Uzbek Value')}</label>
                            <input
                              type='text'
                              name='carrentalsname'
                              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                              placeholder={t('Uzbek Value')}
                              value={item.uz_name}
                              onChange={(event: any) =>
                                handleCarRentalsChange(index, 'uz_name', event.target.value)
                              }
                            ></input>
                            <label className='text-danger'>{error[`uz_name${index}`] || ''}</label>
                          </div>
                          <div className='col-lg-3 col-xl-1'>
                            <div className='col-2' style={{textAlign: 'right', marginTop: '1rem'}}>
                              <label
                                onClick={() => removeCarRentals(item.id, index)}
                                className='btn btn-danger'
                              >
                                <FontAwesomeIcon icon={faMinus} />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
            </div>
            <div className='row'>
              <div className='col-12' style={{textAlign: 'right'}}>
                {props.passSecurityData.apiName == 'securitydeposite' ? (
                  <label
                    className='btn btn-success'
                    onClick={() => {
                      addCarRentalsSecurity()
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </label>
                ) : props.passSeatData.apiName == 'seatnumber' ? (
                  <label
                    className='btn btn-success'
                    onClick={() => {
                      addCarRentalSeat()
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </label>
                ) : (
                  <label
                    className='btn btn-success'
                    onClick={() => {
                      addCarRentals()
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </label>
                )}
              </div>
            </div>

            {/* action button start */}
            <div className={`d-flex pt-15 justify-content-center`}>
              <button
                type='button'
                className={`btn btn-lg btn-light-success me-3`}
                onClick={props.onHide}
              >
                {t('Cancel')}
              </button>

              <button
                type='button'
                disabled={disable}
                className={`btn btn-lg btn-success monthBtn me-3`}
                onClick={() => validate()}
              >
                {!disable && t('Save')}
                {disable && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {t('Please wait...')}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* action button end */}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

function CarRentals() {
  let t = Tr()
  const {menuIdAdd, menuIdEdit} = useMenuIdPermissions()

  const [showPopup, setShowPopup] = useState(false)
  const [carRentalsList, setCarRentalsList] = useState([])
  const [orgCarRentalsList, setOrgCarRentalsList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)
  const [initalDataLength, setInitalDataLength] = useState('')
  const [passdata, setPassData] = useState<{apiName: string; data: any[]}>({
    apiName: '',
    data: [{en_name: '', ru_name: '', uz_name: ''}],
  })

  const [passSecurityData, setPassSecurityData] = useState<{apiName: string; data: any[]}>({
    apiName: '',
    data: [{from: '', to: ''}],
  })
  const [passSeatData, setPassSeatData] = useState<{apiName: string; data: any[]}>({
    apiName: '',
    data: [{seats: ''}],
  })

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('English Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_name != '' ? row.en_name : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.en_name),
      },
      {
        name: t('Russian Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.ru_name != '' ? row.ru_name : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.ru_name),
        filter: true,
      },
      {
        name: t('Uzbek Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.uz_name != '' ? row.uz_name : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_name),
        filter: true,
      },

      {
        name: t('Values'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.apiName == 'securitydeposite'
                ? row.data.map((item: any) => item.from).join(', ')
                : row.apiName == 'seatnumber'
                ? row.data.map((item: any) => item.seats).join(', ')
                : row.data.map((item: any) => item.en_name).join(', ')}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => row.data.map((item: any) => item.en_name).join(', '),
        filter: true,
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdEdit ? (
              <button
                className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
                title='Edit'
                onClick={() => {
                  if (row.apiName == 'securitydeposite') {
                    const trimDatasecurity = (data: any[]) => {
                      return data.map((item) => ({
                        from: item.from || '',
                        to: item.to || '',
                        id: item.id || '',
                      }))
                    }
                    const trimmedDataSecurity = trimDatasecurity(row.data)

                    setPassSecurityData({apiName: row.apiName, data: trimmedDataSecurity})
                    setShowPopup(true)
                  } else if (row.apiName == 'seatnumber') {
                    const trimDataSeat = (data: any[]) => {
                      return data.map((item) => ({
                        seats: item.seats || '',
                        id: item.id || '',
                      }))
                    }
                    const trimmedDataSeat = trimDataSeat(row.data)

                    setPassSeatData({apiName: row.apiName, data: trimmedDataSeat})
                    setShowPopup(true)
                  } else {
                    const trimData = (data: any[]) => {
                      return data.map((item) => ({
                        en_name: item.en_name?.trim() || '',
                        ru_name: item.ru_name?.trim() || '',
                        uz_name: item.uz_name?.trim() || '',
                        id: item.id || '',
                      }))
                    }
                    const trimmedData = trimData(row.data)

                    setPassData({apiName: row.apiName, data: trimmedData})
                    setShowPopup(true)
                  }
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            ) : (
              ''
            )}
          </>
        ),
        width: '140px',
      },
    ],
    [t]
  )

  const carRentalsListApiCall = async () => {
    var response: any = await fetchData('admin/carrentalsfilter', Object)

    if (response.status == '200') {
      setCarRentalsList(response.data)
      setOrgCarRentalsList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Car Rentals'
    carRentalsListApiCall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Car Rentals')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div
          className='d-flex justify-content-end col-xl-8 '
          data-kt-user-table-toolbar='base'
        ></div>
      </div>
    )
  }

  //search function
  const carRentalsSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text === '' || text == null || text === undefined) {
      setCarRentalsList(orgCarRentalsList)
    } else {
      const tmp: any = orgCarRentalsList.filter((item: any) => {
        const multiSelectLabel = item.multiSelect ? 'Multi Select' : 'Single Select'
        const valuesEnNames = item.values.map((value: any) => value.en_name.toLowerCase())

        return (
          (item.en_name != null &&
            item.en_name !== '' &&
            item.en_name.toLowerCase() === text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name !== '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null &&
            item.ru_name !== '' &&
            item.ru_name.toLowerCase() === text.toLowerCase()) ||
          (item.ru_name != null &&
            item.ru_name !== '' &&
            item.ru_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.uz_name != null &&
            item.uz_name !== '' &&
            item.uz_name.toLowerCase() === text.toLowerCase()) ||
          (item.uz_name != null &&
            item.uz_name !== '' &&
            item.uz_name.toLowerCase().includes(text.toLowerCase())) ||
          multiSelectLabel.toLowerCase().includes(text.toLowerCase()) ||
          valuesEnNames.some((enName: string) => enName.includes(text.toLowerCase()))
        )
      })
      setCarRentalsList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgCarRentalsList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={carRentalsList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader
                      search={searchTerm}
                      isfoc={focus}
                      customSearch={carRentalsSearch}
                    />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                    <h2 className='fs-2x fw-bold '>{t('Welcome To Car Rentals')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold'>{t('There are no Car Rentals')}</p>
                  {menuIdAdd ? (
                    <Link
                      to='#'
                      className='btn btn-success monthBtn'
                      onClick={() => setShowPopup(true)}
                    >
                      {t('Add Car Rentals')}
                    </Link>
                  ) : (
                    ''
                  )}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            passdata={passdata}
            passSecurityData={passSecurityData}
            passSeatData={passSeatData}
            onHide={() => {
              setShowPopup(false)
              setPassSecurityData({apiName: '', data: [{from: '', to: ''}]})
              setPassSeatData({apiName: '', data: [{seats: ''}]})

              carRentalsListApiCall()
            }}
          />
        )}
      </div>
    </>
  )
}

export default CarRentals
